export default "__VITE_ASSET__grJ4lAqw__"